import { FormControl, FormHelperText, InputLabel, LinearProgress, MenuItem } from '@material-ui/core'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import { Select } from 'formik-material-ui'
import React, { memo, useEffect, useState } from 'react'

import { fetchCereales } from '../../../../../../../models/cereal/cereal'

export const CerealesSelect = memo(() => {
  const [cereales, setCereales] = useState([])
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const {
    errors: { cereal: error }
  } = useFormikContext()
  useEffect(
    () => {
      (async () => {
        try {
          setLoading(true)
          setCereales(await fetchCereales())
          setDisabled(false)
          setLoading(false)
        } catch (error) {
          setCereales([])
          setDisabled(true)
          setLoading(false)
        }
      })()
    },
    []
  )
  return (
    <FormControl style={{ width: '100%' }} variant='outlined' error={!!error}>
      <InputLabel id='cereal-label'>Cereal</InputLabel>
      <Field
        component={Select}
        name='cereal'
        label='Cereal'
        inputProps={{
          labelId: 'cereal-label',
          id: 'cereal'
        }}
        disabled={disabled}
      >
        {cereales.map((cereal) => (
          <MenuItem key={cereal.nombreCorto} value={cereal.nombreCorto}>{cereal.nombre}</MenuItem>
        ))}
      </Field>
      {loading && <LinearProgress />}
      <ErrorMessage name='cereal'>
        {(error) => <FormHelperText>{error}</FormHelperText>}
      </ErrorMessage>
    </FormControl>
  )
})
